import { fetchAndParse, jsonHeaders } from '#lib/helpers/fetch.js';
import { useAuthQuery } from '#lib/hooks/use-query.js';

async function fetchSupportedLanguages(_, authHeaders) {
    const response = await fetchAndParse(`${API_URL}/p/supportedLanguages`, {
        method: 'GET',
        headers: { ...jsonHeaders, ...authHeaders }
    });
    return response;
}

export default function useSupportedLanguages() {
    const { data, ...flags } = useAuthQuery({
        queryFn: fetchSupportedLanguages,
        queryKey: ['supported-languages'],
    });

    return { data, ...flags };
}
